import Component from '@glimmer/component'
import { SideNavAccordionItem, SideNavAccordionList } from 'teacher-ui-client/components/side-nav/accordion'
import { service } from '@ember/service'
import paperPlaneUnfilled from '@images/icons/paper-plane-unfilled.svg'
import { t } from 'ember-intl'
import type SideNavService from 'teacher-ui-client/services/side-nav'

export class WritingSideNavQuickLinksAccordion extends Component {
  @service sideNav!: SideNavService

  get isVisible() {
    return !this.sideNav.isHomeschool
  }

  <template>
    {{#if this.isVisible}}
      <SideNavAccordionList
        @iconUrl={{paperPlaneUnfilled}}
        @iconAlt="Sidenav plane"
        @label={{t "sideNav.quickLinks.title"}}
      >
        <SideNavAccordionItem @route="subscription-type.quick-links.research-reports">
          {{t "sideNav.quickLinks.researchReports"}}
        </SideNavAccordionItem>

        <SideNavAccordionItem @route="subscription-type.quick-links.teacher-guides">
          {{t "sideNav.quickLinks.userGuides"}}
        </SideNavAccordionItem>
      </SideNavAccordionList>
    {{/if}}
  </template>
}

export default WritingSideNavQuickLinksAccordion
